import type { Dispatch, SetStateAction } from "react";

interface AppendImagePreviewFilesArgs {
  files: File[];
  currentImageCount: number;
  maxImages: number;
  setImageFiles: Dispatch<SetStateAction<File[]>>;
  setImagePreviews: Dispatch<SetStateAction<string[]>>;
}

export function appendImagePreviewFiles({
  files,
  currentImageCount,
  maxImages,
  setImageFiles,
  setImagePreviews,
}: AppendImagePreviewFilesArgs) {
  if (files.length === 0) return;

  const remaining = maxImages - currentImageCount;
  if (remaining <= 0) return;

  const newFiles = files.slice(0, remaining);
  newFiles.forEach((file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      setImagePreviews((prev) => [...prev, event.target?.result as string]);
    };
    reader.readAsDataURL(file);
  });

  setImageFiles((prev) => [...prev, ...newFiles]);
}

export function removeIndexedStateItem<T>(setItems: Dispatch<SetStateAction<T[]>>, index: number) {
  setItems((prev) => prev.filter((_, itemIndex) => itemIndex !== index));
}
